'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoKnife = function IoKnife(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm22.3 2.5c0.2 0 0.2 0.1 0.2 0.5v32.2c0 1.1-0.8 2.3-1.9 2.3-1.1 0-1.8-1.2-1.8-2.3 0-1.5 1-6.5 1.2-10.2 0.1-2.3-2.5-2.4-2.5-5.5 0-10.4 2.7-14.9 4.2-16.7 0.2-0.1 0.4-0.3 0.6-0.3z' })
        )
    );
};

exports.default = IoKnife;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/knife.js
// module id = 2329
// module chunks = 0